const general = {
  "imgs": {
    "placeholder": "https://dummyimage.com/300x150/f5f5f5/000.gif",
    "success_icon": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/success-icon.svg",
    "error_icon": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/error-icon.svg",
    "refresh_icon": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/refresh-icon.svg",
    "scale_equal": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/scale-equal.png",
    "scale_purple": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/scale-purple.png",
    "scale_yellow": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/scale-yellow.png",
    "party_a_house": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/purple-house.svg",
    "party_b_house": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/yellow-house.svg",
    "result_1": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/challenge-result-1.png",
    "result_2": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/challenge-result-2.png",
    "result_3": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/challenge-result-3.png",
    "result_4": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/challenge-result-4.png"
  }
};

const challenges = [
  {
    "challenge": 1,
    "type": "intro",
    "image": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/challenge-1.png",
    "flashline": "Gerrymandering: The Game!",
    "headline": "Welcome to Statesota",
    "dek": "Population 12",
    "text": "The state is evenly split between voters from the Purple and Yellow parties. Ideally, candidates from either would have a fair shot at winning.<br><br>Can you create three districts with an even number of purple and yellow voters in each one?",
    "buttons": [{
      "text": "Begin game",
      "goto": "1.how-to"
    }]
  },
  {
    "challenge": 1,
    "type": "how-to",
    "title": "How to play",
    "image": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/how-to.gif",
    "text": [
      "Select a house to start drawing a district.",
      "Houses within a district must be on adjacent lots.",
      "Once you select enough houses to complete a district, you will automatically start drawing the next one."
    ],
    "buttons": [{
      "text": "Start challenge, 1 of 4",
      "goto": "1.challenge"
    }]
  },
  {
    "challenge": 1,
    "type": "challenge",
    "title": "Challenge one",
    "subtitle": "Balance the Districts",
    "description": "Create three districts with equal numbers of purple and yellow voters. Each district should have four houses on adjacent lots.",
    "population": ["50%", "50%"],
    "buttons": [{
      "text": "Reset",
      "goto": "1.challenge",
      "type": "reset"
    },
    {
      "text": "Submit",
      "goto": "1.check"
    }],
    "game_info": {
      "answers": [],
      "num_squares": 4,
      "answers_count": 12,
      "squares": [
        {
          "id": 1,
          "owns": null,
          "party": "a"
        },
        {
          "id": 2,
          "owns": null,
          "party": "a"
        },
        {
          "id": 3,
          "owns": null,
          "party": "b"
        },
        {
          "id": 4,
          "owns": 5,
          "party": "a"
        },
        {
          "id": 5,
          "owns": 4,
          "party": null
        },
        {
          "id": 6,
          "owns": null,
          "party": "a"
        },
        {
          "id": 7,
          "owns": null,
          "party": "b"
        },
        {
          "id": 8,
          "owns": null,
          "party": "b"
        },
        {
          "id": 9,
          "owns": 10,
          "party": null
        },
        {
          "id": 10,
          "owns": 9,
          "party": "b"
        },
        {
          "id": 11,
          "owns": null,
          "party": "b"
        },
        {
          "id": 12,
          "owns": 13,
          "party": "a"
        },
        {
          "id": 13,
          "owns": 12,
          "party": null
        },
        {
          "id": 14,
          "owns": 15,
          "party": null
        },
        {
          "id": 15,
          "owns": 14,
          "party": "b"
        },
        {
          "id": 16,
          "owns": null,
          "party": null
        },
        {
          "id": 17,
          "owns": null,
          "party": null
        },
        {
          "id": 18,
          "owns": 19,
          "party": "a"
        },
        {
          "id": 19,
          "owns": 18,
          "party": null
        },
        {
          "id": 20,
          "owns": null,
          "party": null
        }
      ],
      "outcomes": {
        "a": [
          [1,2,3,8],
          [6,7,11,12],
          [4,10,15,18]
        ],
        "b": [
          [1,6,7,11],
          [2,3,4,8],
          [10,12,15,18]
        ],
        "c": [
          [1,6,7,11],
          [2,3,4,10],
          [8,12,15,18]
        ],
        "d": [
          [1,6,7,11],
          [2,3,8,12],
          [4,10,15,18]
        ],
        "e": [
          [1,6,7,8],
          [2,3,4,10],
          [11,12,15,18]
        ]
      }
    }
  },
  {
    "challenge": 1,
    "type": "results-success",
    "title": "Your state's districts",
    "text": "Well done. Candidates from either party would have an opportunity to win election.",
    "result_text": "Goal accomplished",
    "population": ["50%","50%"],
    "buttons": [{
      "text": "Next challenge",
      "goto": "2.intro"
    }]
  },
  {
    "challenge": 1,
    "type": "results-error",
    "title": "Your state's districts",
    "text": "These districts do not each have an equal number of purple and yellow voters.",
    "result_text": "Goal not achieved. Try again.",
    "population": ["50%","50%"],
    "buttons": [{
        "text": "Try again",
        "goto": "1.challenge",
        "type": "reset"
      },
      {
        "text": "See an answer",
        "goto": "1.show-answer"
      }
    ]
  },
  {
    "challenge": 1,
    "type": "show-answer",
    "image": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/challenge-result-1.png",
    "title": "Possible district",
    "text": "Here is one of several possible correct answers.",
    "population": ["50%","50%"],
    "buttons": [{
        "text": "Next challenge",
        "goto": "2.intro"
      }
    ]
  },
  {
    "challenge": 2,
    "type": "intro",
    "title": "Challenge two",
    "image": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/challenge-2.gif",
    "text": "Say the governor is a member of the Purple Party. She wants to gerrymander the district lines to give her party control in the next election and asks you to help. Can you create two districts that would vote purple and one that would vote yellow?",
    "buttons": [{
      "text": "Start challenge, 2 of 4",
      "goto": "2.challenge"
    }]
  },
  {
    "challenge": 2,
    "type": "challenge",
    "title": "Challenge two",
    "subtitle": "GIVE PURPLE PARTY A BOOST",
    "description": "Create two purple districts and one yellow district. Each district should have four houses on adjacent lots.",
    "population": ["50%", "50%"],
    "buttons": [{
      "text": "Reset",
      "goto": "2.challenge",
      "type": "reset"
    },
    {
      "text": "Submit",
      "goto": "2.check"
    }],
    "game_info": {
      "answers": [],
      "num_squares": 4,
      "answers_count": 12,
      "squares": [
        {
          "id": 1,
          "owns": null,
          "party": "a"
        },
        {
          "id": 2,
          "owns": null,
          "party": "a"
        },
        {
          "id": 3,
          "owns": null,
          "party": "b"
        },
        {
          "id": 4,
          "owns": 5,
          "party": "a"
        },
        {
          "id": 5,
          "owns": 4,
          "party": null
        },
        {
          "id": 6,
          "owns": null,
          "party": "a"
        },
        {
          "id": 7,
          "owns": null,
          "party": "b"
        },
        {
          "id": 8,
          "owns": null,
          "party": "b"
        },
        {
          "id": 9,
          "owns": 10,
          "party": null
        },
        {
          "id": 10,
          "owns": 9,
          "party": "b"
        },
        {
          "id": 11,
          "owns": null,
          "party": "b"
        },
        {
          "id": 12,
          "owns": 13,
          "party": "a"
        },
        {
          "id": 13,
          "owns": 12,
          "party": null
        },
        {
          "id": 14,
          "owns": 15,
          "party": null
        },
        {
          "id": 15,
          "owns": 14,
          "party": "b"
        },
        {
          "id": 16,
          "owns": null,
          "party": null
        },
        {
          "id": 17,
          "owns": null,
          "party": null
        },
        {
          "id": 18,
          "owns": 19,
          "party": "a"
        },
        {
          "id": 19,
          "owns": 18,
          "party": null
        },
        {
          "id": 20,
          "owns": null,
          "party": null
        }
      ],
      "outcomes": {
        "a": [
          [1,2,3,4],
          [6,11,12,18],
          [7,8,10,15]
        ]
      }
    }
  },
  {
    "challenge": 2,
    "type": "results-success",
    "title": "Your state's districts",
    "text": "Well done. The Purple Party will have an easier time staying in power.",
    "result_text": "Goal accomplished",
    "population": ["50%","50%"],
    "buttons": [{
      "text": "Next challenge",
      "goto": "3.intro"
    }]
  },
  {
    "challenge": 2,
    "type": "results-error",
    "title": "Your state's districts",
    "text": "Oops, these districts won't benefit the Purple Party.",
    "result_text": "Goal not achieved. Try again.",
    "population": ["50%","50%"],
    "buttons": [{
        "text": "Try again",
        "goto": "2.challenge",
        "type": "reset"
      },
      {
        "text": "See an answer",
        "goto": "2.show-answer"
      }
    ]
  },
  {
    "challenge": 2,
    "type": "show-answer",
    "image": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/challenge-result-2.png",
    "title": "Possible district",
    "text": "Here is one of several possible correct answers.",
    "population": ["50%","50%"],
    "buttons": [{
        "text": "Next challenge",
        "goto": "3.intro"
      }
    ]
  },
  {
    "challenge": 3,
    "type": "intro",
    "title": "Challenge three",
    "image": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/challenge-3.gif",
    "text": "Purple Party now controls the state legislature. As more people move into Statesota, all happen to be members of the Yellow Party. However, with gerrymandering, the Purple Party can still stay in power. Can you create two purple districts and one yellow district so that Purple stays in control? Now districts will each have five houses.",
    "asset_url": "https://dummyimage.com/300x150/f5f5f5/000.gif",
    "buttons": [{
      "text": "Start challenge, 3 of 4",
      "goto": "3.challenge"
    }]
  },
  {
    "challenge": 3,
    "type": "challenge",
    "title": "Challenge three",
    "subtitle": "KEEP PURPLE IN POWER",
    "description": "Create two purple districts and one yellow district. Each district should have five houses on adjacent lots.",
    "population": ["40%", "60%"],
    "buttons": [{
      "text": "Reset",
      "goto": "3.challenge",
      "type": "reset"
    },
    {
      "text": "Submit",
      "goto": "3.check"
    }],
    "game_info": {
      "answers": [],
      "num_squares": 5,
      "answers_count": 15,
      "squares": [
        {
          "id": 1,
          "owns": null,
          "party": "a"
        },
        {
          "id": 2,
          "owns": null,
          "party": "a"
        },
        {
          "id": 3,
          "owns": null,
          "party": "b"
        },
        {
          "id": 4,
          "owns": null,
          "party": "a"
        },
        {
          "id": 5,
          "owns": null,
          "party": "b"
        },
        {
          "id": 6,
          "owns": null,
          "party": "a"
        },
        {
          "id": 7,
          "owns": null,
          "party": "b"
        },
        {
          "id": 8,
          "owns": null,
          "party": "b"
        },
        {
          "id": 9,
          "owns": null,
          "party": "b"
        },
        {
          "id": 10,
          "owns": null,
          "party": "b"
        },
        {
          "id": 11,
          "owns": null,
          "party": "b"
        },
        {
          "id": 12,
          "owns": 13,
          "party": "a"
        },
        {
          "id": 13,
          "owns": 12,
          "party": null
        },
        {
          "id": 14,
          "owns": 15,
          "party": null
        },
        {
          "id": 15,
          "owns": 14,
          "party": "b"
        },
        {
          "id": 16,
          "owns": null,
          "party": null
        },
        {
          "id": 17,
          "owns": null,
          "party": null
        },
        {
          "id": 18,
          "owns": null,
          "party": "a"
        },
        {
          "id": 19,
          "owns": null,
          "party": "b"
        },
        {
          "id": 20,
          "owns": null,
          "party": null
        }
      ],
      "outcomes": {
        "a": [
          [1,2,3,4,5],
          [6,7,11,12,18],
          [8,9,10,15,19]
        ],
        "b": [
          [1,2,3,4,5],
          [6,11,12,18,19],
          [7,8,9,10,15]
        ],
        "c": [
          [1,2,3,4,8],
          [5,9,10,15,19],
          [6,7,11,12,18]
        ],
        "d": [
          [1,2,6,7,11],
          [3,4,8,12,18],
          [5,9,10,15,19]
        ],
        "e": [
          [1,2,3,4,7],
          [6,11,12,18,19],
          [5,8,9,10,15]
        ]
      }
    }
  },
  {
    "challenge": 3,
    "type": "results-success",
    "title": "Your state's districts",
    "text": "Well done. Although only 40% of the population in the state voted Purple, the party still stayed in power.",
    "result_text": "Goal accomplished",
    "population": ["40%","60%"],
    "buttons": [{
      "text": "Next challenge",
      "goto": "4.intro"
    }]
  },
  {
    "challenge": 3,
    "type": "results-error",
    "title": "Your state's districts",
    "text": "It looks like you made fair districts but they aren't gerrymandered to benefit the Purple Party.",
    "result_text": "Goal not achieved. Try again.",
    "population": ["40%","60%"],
    "buttons": [{
        "text": "Try again",
        "goto": "3.challenge",
        "type": "reset"
      },
      {
        "text": "See an answer",
        "goto": "3.show-answer"
      }
    ]
  },
  {
    "challenge": 3,
    "type": "show-answer",
    "image": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/challenge-result-3.png",
    "title": "Possible district",
    "text": "Here is one of several possible correct answers.",
    "population": ["50%","50%"],
    "buttons": [{
        "text": "Next challenge",
        "goto": "4.intro"
      }
    ]
  },
  {
    "challenge": 4,
    "type": "intro",
    "title": "Challenge four",
    "image": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/challenge-4.gif",
    "text": "Members of each party tend to cluster toward each other, which can complicate gerrymandering. Redraw the districts so there are still two purple districts and one yellow district.",
    "buttons": [{
      "text": "Start challenge, 4 of 4",
      "goto": "4.challenge"
    }]
  },
  {
    "challenge": 4,
    "type": "challenge",
    "title": "Challenge four",
    "subtitle": "BREAK UP CLUSTERS",
    "description": "Create two purple districts and one yellow district. Each district should have five houses on adjacent lots.",
    "population": ["40%", "60%"],
    "buttons": [{
      "text": "Reset",
      "goto": "4.challenge",
      "type": "reset"
    },
    {
      "text": "Submit",
      "goto": "4.check"
    }],
    "game_info": {
      "answers": [],
      "num_squares": 5,
      "answers_count": 15,
      "squares": [
        {
          "id": 1,
          "owns": null,
          "party": "a"
        },
        {
          "id": 2,
          "owns": null,
          "party": "a"
        },
        {
          "id": 3,
          "owns": null,
          "party": "b"
        },
        {
          "id": 4,
          "owns": null,
          "party": "b"
        },
        {
          "id": 5,
          "owns": null,
          "party": "b"
        },
        {
          "id": 6,
          "owns": null,
          "party": "a"
        },
        {
          "id": 7,
          "owns": null,
          "party": "a"
        },
        {
          "id": 8,
          "owns": null,
          "party": "b"
        },
        {
          "id": 9,
          "owns": null,
          "party": "b"
        },
        {
          "id": 10,
          "owns": null,
          "party": "b"
        },
        {
          "id": 11,
          "owns": null,
          "party": "a"
        },
        {
          "id": 12,
          "owns": 13,
          "party": "a"
        },
        {
          "id": 13,
          "owns": 12,
          "party": null
        },
        {
          "id": 14,
          "owns": 15,
          "party": null
        },
        {
          "id": 15,
          "owns": 14,
          "party": "b"
        },
        {
          "id": 16,
          "owns": null,
          "party": null
        },
        {
          "id": 17,
          "owns": null,
          "party": null
        },
        {
          "id": 18,
          "owns": null,
          "party": "b"
        },
        {
          "id": 19,
          "owns": null,
          "party": "b"
        },
        {
          "id": 20,
          "owns": null,
          "party": null
        }
      ],
      "outcomes": {
        "a": [
          [1,2,3,4,6],
          [5,8,9,10,15],
          [7,11,12,18,19]
        ],
        "b": [
          [1,2,3,4,6],
          [5,10,15,18,19],
          [7,8,9,11,12]
        ],
        "c": [
          [1,2,3,6,8],
          [4,5,9,10,15],
          [7,11,12,18,19]
        ],
        "d": [
          [1,2,3,4,6],
          [5,9,10,15,19],
          [7,8,11,12,18]
        ],
        "e": [
          [1,2,3,7,8],
          [4,5,9,10,15],
          [6,11,12,18,19]
        ],
        "f": [
          [1,6,11,18,19],
          [2,3,7,8,12],
          [4,5,9,10,15]
        ],
        "g": [
          [1,6,11,18,19],
          [2,3,4,7,12],
          [5,8,9,10,15]
        ],
        "h": [
          [1,6,11,18,19],
          [2,3,7,12,15],
          [4,5,8,9,10]
        ],
        "i": [
          [1,6,11,18,19],
          [2,7,8,12,15],
          [3,4,5,9,10]
        ],
        "j": [
          [1,6,11,18,19],
          [2,7,9,12,15],
          [3,4,5,8,10]
        ],
        "k": [
          [1,6,11,18,19],
          [2,7,10,12,15],
          [3,4,5,8,9]
        ],
        "l": [
          [1,6,11,18,19],
          [2,7,8,9,12],
          [3,4,5,10,15]
        ],
        "m": [
          [1,6,8,11,18],
          [2,3,4,7,12],
          [5,9,10,15,19]
        ],
        "n": [
          [1,2,7,8,9],
          [3,4,5,10,15],
          [6,11,12,18,19]
        ],
        "o": [
          [1,2,3,4,7],
          [5,10,11,18,19],
          [6,8,9,11,12]
        ],
        "p": [
          [1,2,3,4,7],
          [5,8,9,10,15],
          [6,11,12,18,19]
        ],
        "q": [
          [1,2,3,4,7],
          [6,8,11,12,18],
          [5,9,10,15,19]
        ],
        "r": [
          [1,2,3,4,7],
          [5,10,15,18,19],
          [6,8,9,11,12]
        ]
      }
    }
  },
  {
    "challenge": 4,
    "type": "results-success",
    "title": "Your state's districts",
    "text": "You got creative with those district lines. The Purple Party is still in control.",
    "result_text": "Goal accomplished",
    "population": ["40%","60%"],
    "buttons": [{
      "text": "Next",
      "goto": "5.intro"
    }]
  },
  {
    "challenge": 4,
    "type": "results-error",
    "title": "Your state's districts",
    "text": "It looks like you made fair districts but they aren't gerrymandered to benefit the Purple Party.",
    "result_text": "Goal not achieved. Try again.",
    "population": ["40%", "60%"],
    "buttons": [{
        "text": "Try again",
        "goto": "4.challenge",
        "type": "reset"
      },
      {
        "text": "See an answer",
        "goto": "4.show-answer"
      }
    ]
  },
  {
    "challenge": 4,
    "type": "show-answer",
    "image": "https://asset.wsj.net/wsjnewsgraphics/gerrymander/assets/challenge-result-4.png",
    "title": "Possible district",
    "text": "Here is one of several possible correct answers.",
    "population": ["50%","50%"],
    "buttons": [{
        "text": "Finish",
        "goto": "5.intro"
      }
    ]
  },
  {
    "challenge": 5,
    "type": "intro",
    "text": "<div class=\"credits\"<br><br><br><h6>Credits</h6>Development: <a target=\"_blank\" href=\"https://twitter.com/dov_friedman\">Dov Friedman</a>, <a target=\"_blank\" href=\"https://twitter.com/tynandebold\">Tynan DeBold</a><br>Concept: <a target=\"_blank\" href=\"https://twitter.com/brian_mcgill\">Brian McGill</a><br>Design: <a target=\"_blank\" href=\"https://twitter.com/jessiekuronen\">Jess Kuronen</a></div>",
    "population": ["",""],
    "buttons": [{
        "text": "Restart Game",
        "goto": "1.intro"
      }
    ]
  }
];

export {
  general,
  challenges
};



// WEBPACK FOOTER //
// ./src/data.js